<template>
    <div>
        <form @submit.prevent="create">
            <div class="modal-body modal-row2 modal-height-max mt-2 pl-2 pr-2">
                <SectionCardComponent
                        eyebrow="Reserva"
                        title="Informações da reserva"
                        subtitle="Confira o loteamento e informe os dados obrigatórios para criar a reserva."
                        icon="icon-home"
                        custom-class="reserve-info-card">
                    <template #actions>
                        <div class="reserve-allotment-display" v-if="allotments">
                            <span class="reserve-allotment-display__icon">
                                <i class="icon-map-pin"></i>
                            </span>
                            <span class="reserve-allotment-display__content">
                                <span class="reserve-allotment-display__label">{{ t('LOTS.ALLOTMENT') }}</span>
                                <strong>{{ allotmentLabel }}</strong>
                            </span>
                        </div>
                    </template>

                    <div class="row gutters mt-2">
                        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                            <div class="form-group">
                                <label
                                        for="reserveType" class="required">{{ t('NAV.RESERVE_TYPES') }}: </label>
                                <Select2
                                        :settings="{ width: '100%', disabled: true}"
                                        id="reserveType"
                                        name="reserveType"
                                        v-model="reserve.reserve_type_id"
                                        :options="reserveTypes"
                                        @select="selectGeneric(reserve.reserve_type_id, 'ReserveTypes'), validateReserveDuration(reserve.reserve_type_id, reserveTypes)"
                                        v-if="isRealtor"/>
                                <Select2
                                        :settings="{ width: '100%', placeholder: t('GENERAL.MSG.SELECT_ONE', {article: 'um', name: t('NAV.RESERVE_TYPES')}) }"
                                        id="reserveType" name="reserveType" v-model="reserve.reserve_type_id"
                                        :options="reserveTypes"
                                        @select="selectGeneric(reserve.reserve_type_id, 'ReserveTypes'), validateReserveDuration(reserve.reserve_type_id, reserveTypes)"
                                        v-if="!isRealtor"/>
                                <div
                                        class="validation"
                                        id="invalidReserveTypes"
                                        style="display: none">
                                    {{ t('GENERAL.MSG.REQUIRED_FIELD') }}
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-2 col-md-3 col-sm-6 col-6">
                            <div class="form-group">
                                <label
                                        for="block" class="required">{{ t('LOTS.BLOCK') }}: </label>
                                <Select2
                                        :settings="{ width: '100%', placeholder:  reserve.blocks, disabled: true}"
                                        v-if="reserve.isLotOrigin"/>
                                <Select2
                                        :settings="{ width: '100%', placeholder: '000', disabled: true}"
                                        :options="block"
                                        v-if="isLoadingBlocks && !reserve.isLotOrigin"/>
                                <Select2
                                        :settings="{ width: '100%', placeholder: '000' }"
                                        id="block"
                                        name="block"
                                        v-if="!isLoadingBlocks && !reserve.isLotOrigin"
                                        v-model="reserve.block"
                                        :options="blocks"
                                        @select="blockSelected($event, reserve.allotment_id)"/>
                                <div class="validation"
                                     id="invalidBlock" style="display: none">{{
                                        t('GENERAL.MSG.REQUIRED_FIELD')
                                    }}
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-2 col-md-3 col-sm-6 col-6">
                            <div class="form-group">
                                <label
                                        for="lot" class="required">{{ t('LOTS.LOT') }}: </label>
                                <Select2 :settings="{ width: '100%', disabled: true}"
                                         v-model="reserve.property_id"
                                         :options="reserve.lots" v-if="reserve.isLotOrigin"/>
                                <Select2
                                        :settings="{ width: '100%', placeholder: '0000', disabled: true}"
                                        :options="lots"
                                        v-if="isLoadingLots && !reserve.isLotOrigin"/>
                                <Select2
                                        :settings="{ width: '100%', placeholder: '0000'}"
                                        id="lot"
                                        name="lot"
                                        v-model="reserve.property_id"
                                        :options="lots"
                                        @select="selectGeneric(reserve.property_id, 'Lot')"
                                        v-if="!isLoadingLots && !reserve.isLotOrigin"/>
                                <div class="validation"
                                     id="invalidLot" style="display: none">{{
                                        t('GENERAL.MSG.REQUIRED_FIELD')
                                    }}
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12 col-12">
                            <div class="form-group" >
                                <label
                                        for="reserveDuration" :class="hasDuration ? 'required' : ''">{{ t('RESERVE.DURATION') }}: </label>
                                <input
                                        class="form-control text-center"
                                        type="text"
                                        id="reserveDuration"
                                        name="reserveDuration"
                                        v-model.lazy="reserve.reserve_duration"
                                        v-money3="configDuration"
                                        @keyup="inputReserve"
                                        :disabled="isLoadingBlocks || isRealtor || !hasDuration">
                                <div class="validation"
                                     id="invalidReserve" style="display: none">{{ msgReserve }}
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div class="form-group">
                                <label
                                        for="realtor" class="required">{{ t('RESERVE.REALTOR') }}: </label>
                                <Select2
                                        :settings="{ width: '100%', placeholder: t('GENERAL.MSG.SELECT_ONE', {article: 'um', name: t('RESERVE.REALTOR')}), disabled: true}"
                                        :options="realtors"
                                        v-if="isLoadingBlocks"/>
                                <Select2
                                        :settings="{ width: '100%', disabled: realtors?.length===1}"
                                        id="realtor"
                                        name="realtor"
                                        v-model="reserve.realtor_id" :options="realtors"
                                        v-if="!isLoadingBlocks && isRealtor"
                                        @select="selectGeneric(reserve.realtor_id, 'Realtors')"/>
                                <Select2
                                        :settings="{ width: '100%', placeholder: t('GENERAL.MSG.SELECT_ONE', {article: 'um', name: t('RESERVE.REALTOR')}) }"
                                        id="realtor" name="realtor"
                                        v-model="reserve.realtor_id" :options="realtors"
                                        v-if="!isLoadingBlocks && !isRealtor"
                                        @select="selectGeneric(reserve.realtor_id, 'Realtors')"/>
                                <div class="validation"
                                     id="invalidRealtors" style="display: none">{{
                                        t('GENERAL.MSG.REQUIRED_FIELD')
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>
                </SectionCardComponent>
                <SectionCardComponent
                        eyebrow="Clientes"
                        title="Clientes vinculados a esta reserva"
                        subtitle="Adicione os compradores a esta reserva."
                        icon="icon-users"
                        :title-class="isRequiredDataClient ? 'required' : ''"
                        custom-class="reserve-clients-section">
                    <template #actions>
                        <button
                                class="btn btn-primary reserve-clients-add"
                                @click.stop.prevent="setAddClient">
                            <i class="icon-circle-with-plus"></i>
                            <span>Adicionar cliente</span>
                        </button>
                    </template>

                    <div
                            class="card-custom reserve-clients-panel"
                            id="clients">
                        <div class="reserve-clients-list" v-if="clients[0]">
                            <div
                                    class="background-table reserve-client-card"
                                    v-for="(client, key) in clients"
                                    :key="key">
                                <div class="reserve-client-card__avatar">
                                    {{ (client.name || '?').charAt(0) }}
                                </div>
                                <div class="reserve-client-card__main">
                                    <div class="reserve-client-card__identity">
                                        <span class="reserve-client-card__label">{{ t('GENERAL.NAME') }}</span>
                                        <strong>{{ client.name }}</strong>
                                        <span class="reserve-client-card__taxpayer">
                                            <i class="icon-credit-card"></i>
                                            {{ client.taxpayer }}
                                        </span>
                                    </div>

                                    <div class="reserve-client-card__details">
                                        <div class="reserve-client-card__field reserve-client-card__field--phone">
                                            <span class="reserve-client-card__label">{{ t('GENERAL.PHONE') }}</span>
                                            <vue-tel-input
                                                    v-model="client.phones[0].number"
                                                    disabled
                                                    mode="national"
                                                    :autoFormat="true"
                                                    :preferredCountries="['US', 'DE', 'FR', 'CN']"
                                                    :defaultCountry="client?.phones[0]?.code_country ? parseInt(client.phones[0].code_country) : 55"
                                                    :dropdownOptions="dropdownOptions"
                                                    :inputOptions="inputOptions"
                                            ></vue-tel-input>
                                        </div>

                                        <div class="reserve-client-card__field">
                                            <span class="reserve-client-card__label">{{ t('GENERAL.EMAIL') }}</span>
                                            <span class="reserve-client-card__email" :class="{'reserve-client-card__email--empty': !client.email}">
                                                <i class="icon-email"></i>
                                                {{ client.email ? client.email : 'Não Informado' }}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="reserve-client-card__actions">
                                    <a
                                            class="btn btn-custom bg-btn reserve-client-card__delete"
                                            :title="t('ACTIONS.DELETE')"
                                            @click.stop.prevent="deleteClient(key)">
                                        <i class="icon-trash"></i>
                                        <span>Remover</span>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div
                                class="reserve-clients-empty text-center"
                                v-if="!clients[0]">
                            <div class="reserve-clients-empty__icon">
                                <i class="icon-users"></i>
                            </div>
                            <strong>{{ t('GENERAL.MSG.NONE_COSTUMER_SELECTED') }}</strong>
                            <small v-if="isRequiredDataClient">
                                Este campo e obrigatório para continuar com a reserva.
                            </small>
                        </div>
                    </div>
                </SectionCardComponent>
                <div class="reserve-observation-field">
                    <div class="form-group mb-0">
                        <label for="comments" class="reserve-observation-field__label">
                            <i class="icon-file-text"></i>
                            {{ t('GENERAL.COMMENTS') }}
                        </label>
                        <textarea
                                class="form-control reserve-observation-field__textarea"
                                id="comments"
                                rows="3"
                                v-model="reserve.observation"></textarea>
                    </div>
                </div>
            </div>
            <div
                    class="modal-footer"
                    style="justify-content: space-between">
                <div>
                    <h5
                            class="ml-3"
                            style="color: red; font-size: .7rem;">{{ t('GENERAL.REQUIRED_FIELDS') }} *</h5>
                </div>
                <div>
                    <button
                            data-cy="reserve_create_close"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                            type="button"
                            @click="closeModal">
                        {{ t('ACTIONS.CLOSE') }}
                    </button>
                    <button
                            data-cy="reserve_create_save"
                            class="btn btn-primary ml-2"
                            type="submit">{{
                            t('ACTIONS.SAVE')
                        }}
                    </button>
                </div>
            </div>
        </form>
        <transition
                name="fade">
            <div
                    class="modal-mask"
                    v-if="addClient">
                <div
                        class="modal-wrapper"
                        data-backdrop="static"
                        data-keyboard="false">
                    <div
                            class="modal-dialog lg"
                            role="document"
                            style="margin-top: 0rem;">
                        <div class="modal-content">
                            <div class="modal-header modal-header-color">
                                <h4 class="modal-title">


                                    Adicionar Cliente


                                </h4>
                                <button type="button"
                                        class="closeX"
                                        id="closeX"
                                        @click.stop.prevent="closeModalClient(false)">
                                    <span
                                            aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div>
                                <div
                                        class="modal-body  mt-2"
                                        style="max-height: calc(100vh - 200px)">
                                    <div class="row gutters">
                                        <div
                                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                                            <div class="form-group">
                                                <label
                                                        for="taxpayer">{{ t('COMPANIES.TAXPAYER') }}: </label>
                                                <input type="text"
                                                       id="taxpayer"
                                                       name="taxpayer"
                                                       v-model="client.taxpayer"
                                                       class="form-control"
                                                        v-mask="['###.###.###-##', 'XX.XXX.XXX/XXXX-##']"
                                                       @keyup="inputTaxpayer(client.taxpayer)"
                                                       @blur="searchClient(client)"
                                                       placeholder="000.000.000-00">
                                                <div
                                                        v-if="isTaxpayerInvalid" class="validation">{{ t(msgTaxpayer) }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                                            <div class="form-group">
                                                <label
                                                        for="brock">{{ t('GENERAL.NAME') }}: </label>
                                                <input type="text"
                                                       id="name"
                                                       name="name"
                                                       v-model="client.name" class="form-control"
                                                       maxlength="60"
                                                       @keyup="inputName(client.name)"
                                                       placeholder="Nome Completo">
                                                <div
                                                        v-if="isNameInvalid" class="validation">{{ t(msgError) }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                                            <div class="form-group">
                                                <label for="phone">{{ t('GENERAL.PHONE') }}: </label>
                                                <vue-tel-input
                                                        ref="vueTelBase"
                                                        v-model="client.phones[0].number"
                                                        :autoFormat="true"
                                                        :preferredCountries="['US', 'DE', 'FR', 'CN']"
                                                        mode="national"
                                                        :defaultCountry="client?.phones[0]?.code_country ? client.phones[0].code_country : 55"
                                                        @country-changed="changeCountry"
                                                        :dropdownOptions="dropdownOptions"
                                                        :inputOptions="inputOptions"
                                                ></vue-tel-input>
                                                <div class="validation"
                                                     id="invalidphone" style="display: none">{{
                                                        msgPhone ? t(msgPhone) : ''
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                                            <div class="form-group">
                                                <label for="phone">{{ t('GENERAL.EMAIL') }}: </label>
                                                <input type="text"
                                                       id="clientEmail"
                                                       name="clientEmail" class="form-control"
                                                       placeholder="E-mail"
                                                       v-model="client.email">
                                                <div class="validation"
                                                     id="invalidEmail"
                                                     v-if="msgEmail">{{
                                                        t(msgEmail)
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                    class="modal-footer justify-content-end">
                                <button
                                        class="btn btn-secondary mr-4" type="button"
                                        @click.stop.prevent="closeModalClient(false)">{{
                                        t("ACTIONS.CLOSE")
                                    }}
                                </button>
                                <button
                                        data-cy="user_index_add_phone_save"
                                        class="btn btn-primary" type="button"
                                        @click.stop.prevent="selectClient(client)">{{ t("ACTIONS.SAVE") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

import {useI18n} from "vue-i18n";
import Lots from '@/services/Lots';
import User from '@/services/user';
import Clients from '@/services/Clients';
import {Money3Directive} from 'v-money3';
import Reserve from '@/services/Reserves';
import {useToast} from "vue-toastification";
import ReserveTypes from "@/services/ReserveTypes";
import Select2 from 'vue3-select2-component';
import Allotments from '@/services/Allotments';
import Validate from '@/components/validate.vue';
import SectionCardComponent from '@/components/layouts/SectionCardComponent.vue';
import {VueTelInput} from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

export default {
    name: 'createReserve',
    props: ['reserveIndex', 'allotmentsIndex', 'blocksIndex', 'reserveTypesIndex', 'isRealtor', 'idModal', 'isDataRequired', 'isEmailRequired'],
    mixins: [Validate],
    directives: {money3: Money3Directive},
    components: {
        Select2,
        SectionCardComponent,
        VueTelInput,
    },
    emits:['close', 'created'],
    setup() {
        const {t} = useI18n();
        const toast = useToast();
        return {t, toast}
    },

    data() {
        return {
            dropdownOptions: {
                showDialCodeInList: true,
                showDialCodeInSelection: true,
                showFlags: true,
                showSearchBox: true,
            },
            inputOptions: {
                autocomplete: 'on',
                autofocus: true,
                'aria-describedby': 'des',
                showDialCode: false,
                placeholder: '',
                tabindex: 1050,
            },
            addClient: false,
            form: null,
            lots: null,
            dataRequired: false,
            block: null,
            reserve: {},
            msgEmail: null,
            invalid: [],
            clients: [],
            isEmailNull: false,
            realtors: [],
            isAdmin: null,
            blocks: null,
            isRequiredDataClient: null,
            msgReserve: '',
            clientsIds: [],
            typeOnlyCall: 1,
            allotments: null,
            isRequiredEmail: false,
            reserveTypes: null,
            hasDuration: false,
            isLoadingLots: true,
            isLoadingBlocks: true,
            reserveDurationMax: null,
            configEditor: {
                height: '200'
            },
            client: {
                phones: [
                    {
                        type: 1,
                        number: '',
                        description: null,
                        code_country: 55,
                        country_acronym: 'BR',
                    }
                ]
            },
            configDuration: {
                min: 0,
                max: 999,
                masked: true,
                decimal: ':',
                precision: 2,
                disabled: false,
                allowBlank: false,
                disableNegative: true,
                minimumNumberOfCharacters: 0
            },
        }
    },

    mounted() {
        this.blocks = this.blocksIndex;
        this.reserve = this.reserveIndex;
        this.allotments = this.allotmentsIndex;
        this.isRequiredDataClient = this.isDataRequired;
        this.isAdmin = this.$hasPermission('Reserve_confirm', true)
        this.allotmentSelected(this.reserve.allotment_id, true);
    },
    computed: {
        allotmentLabel() {
            const allotment = this.allotments?.find(item => item.id == this.reserve?.allotment_id);
            return allotment?.text || allotment?.name || this.reserve?.allotment || this.reserve?.allotment_id || '-';
        },
    },
    watch: {
        isDataRequired: function () {
            document.getElementById('clients').style.backgroundColor = '';
            this.isRequiredDataClient = this.isDataRequired;
        },
        isEmailRequired: function () {
            this.isRequiredEmail = this.isEmailRequired;
        },
        reserveIndex: function () {
            this.clients = [];
            this.resetClient();
            this.clientsIds = [];
            this.hasDuration = false;
            this.isNameInvalid = false;
            this.isLoadingBlocks = true;
            this.blocks = this.blocksIndex;
            this.isTaxpayerInvalid = false;
            this.reserve = this.reserveIndex;
            this.allotments = this.allotmentsIndex;
            this.allotmentSelected(this.reserve.allotment_id, true);
            if (document.getElementById('invalidphone')?.style?.display){
                document.getElementById('invalidphone').style.display = 'none';
            }
            if (document.getElementById('reserveDuration')) {
                document.getElementById('reserveDuration').classList.remove('is-valid');
                document.getElementById('reserveDuration').classList.remove('is-invalid');
            }

        }
    },
    methods: {
        changeCountry(val) {
            this.client.phones[0].code_country = val.dialCode;
            this.client.phones[0].country_acronym = val.iso2;
        },
        closeModalClient(isValidate = false) {
            if (isValidate && this.isTaxpayerInvalid) {
                return;
            }
            this.msgEmail = false;
            this.isNameInvalid = false;
            this.isTaxpayerInvalid = false;
            this.client.taxpayer = null;
            this.client.name = null;
            this.client.email = null;
            this.addClient = false;
            this.client = {
                phones: [
                    {
                        type: 1,
                        number: '',
                        description: null,
                        code_country: 55,
                        country_acronym: 'BR',
                    }
                ]
            }
        },
        setAddClient() {
            this.addClient = true;
        },
        closeModal() {
            document.getElementById('closeX').click();
            this.$emit('close');
        },
        async indexReserveTypes(allotment_id) {
            if (allotment_id) {
                await ReserveTypes.list(allotment_id, true).then(resp => {
                    this.reserveTypes = resp.data;
                }).catch(error => {
                    this.errorMsg(error);
                });
            }
            this.reserve.reserveTypes = [];
            if (this.isRealtor) {
                this.reserve.reserve_type_id = this.reserveTypes[0].id;
                this.validateReserveDuration(this.reserveTypes[0].id, this.reserveTypes);
            }
        },
        indexBlocks(allotment_id) {
            Lots.blocksListAvailable(allotment_id).then(async resp => {
                if (!resp.data.validations) {
                    await (this.blocks = resp.data);
                }
            }).catch(error => {
                this.errorMsg(error);
            });
        },

        indexRealtor(id) {
            User.listRealtor(id, true).then(resp => {
                this.realtors = resp.data;
                if (this.isRealtor && this.realtors?.length == 1) {
                    this.reserve.realtor_id = resp.data[0].id;
                }
            }).catch(error => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(error)
            });
        },

        async indexLots(allotment_id, block) {
            this.isLoadingLots = true;

            await Lots.showLotProperties(allotment_id, block).then(resp => {
                this.lots = resp.data

                this.isLoadingLots = false;
            });
        },

        selectClient(client) {
            if (this.checkClient(client)) {
                if (this.clients.length >= 1) {
                    if (!this.clients.find(c => c.taxpayer === client.taxpayer)) {
                        if (client.id) {
                            if (this.isRequiredEmail && this.isEmailNull) {
                                client.simpleInsert = true;
                                Clients.update(client).then(() => {
                                    this.clients.push(client);
                                    this.clientsIds.push({id: client.id});
                                    this.resetClient();
                                    this.closeModalClient(true);
                                }).catch((err) => {
                                    this.errorMsg(err)
                                })
                            } else {
                                this.clients.push(client);
                                this.clientsIds.push({id: client.id});
                                this.resetClient();
                                this.closeModalClient(true);
                            }
                        } else {
                            client.simpleInsert = true;
                            Clients.create(client).then(resp => {
                                this.clients.push(resp.data);
                                this.clientsIds.push({id: resp.data.id});
                                this.resetClient();
                                this.closeModalClient(true);
                            }).catch((err) => {
                                this.errorMsg(err)
                            });
                        }
                    } else {
                        this.toast.error(this.t('GENERAL.MSG.PREVIOUSLY_REGISTERED_CUSTOMER_INFORMATION'), {timeout: false});
                    }
                } else {
                    if (client.id) {
                        if (this.isRequiredEmail && this.isEmailNull) {
                            client.simpleInsert = true;
                            Clients.update(client).then(() => {
                                this.clients.push(client);
                                this.clientsIds.push({id: client.id});
                                this.resetClient();
                                this.closeModalClient(true);
                            }).catch((err) => {
                                this.errorMsg(err)
                            })
                        } else {
                            this.clients.push(client);
                            this.clientsIds.push({id: client.id});
                            this.resetClient();
                            this.closeModalClient(true);
                        }
                    } else {
                        client.simpleInsert = true;
                        Clients.create(client).then(resp => {
                            this.clients.push(resp.data);
                            this.clientsIds.push({id: resp.data.id});
                            this.resetClient();
                            this.closeModalClient(true);
                        }).catch(err => {
                            this.errorMsg(err)
                        });
                    }
                }
            }
        },

        checkClient(client) {
            this.invalid = [];
            this.nameValidate(client.name);
            if (!client.phones[0]?.number || !client.phones[0]?.number?.length > 3) {
                this.invalid.push(true);
                document.getElementById("invalid" + 'phone').style.display = "block";
                this.msgPhone = "GENERAL.MSG.REQUIRED_FIELD";
            } else {
                document.getElementById("invalid" + 'phone').style.display = "none";
                this.msgPhone = null;
            }

            if (this.isDataRequired && this.isRequiredEmail && !client?.email?.length) {
                document.getElementById('clientEmail')?.classList?.add("is-invalid");
                this.msgEmail = "GENERAL.MSG.REQUIRED_FIELD";
                return false;
            } else {
                document.getElementById('clientEmail')?.classList?.remove("is-invalid");
                this.msgEmail = null;
            }

            if (this.invalid.length && this.invalid.length > 0) {
                return false;
            }
            if (this.isTaxpayerInvalid) {
                return false;
            }
            return true;
        },

        checkForm() {
            this.invalid = [];

            this.reserveDurationValidate();
            this.validateGeneric(this.reserve.block, 'Block', false);
            this.validateGeneric(this.reserve.property_id, 'Lot', false);
            this.validateGeneric(this.reserve.realtor_id, 'Realtors', false);
            this.validateGeneric(this.reserve.reserve_type_id, 'ReserveTypes', false);


            if (this.invalid.length && this.invalid.length > 0) {
                return false;
            }
            return true;
        },

        resetClient() {
            this.client = {
                phones: [{
                    type: 1,
                    number: '',
                    description: null,
                    code_country: 55,
                    country_acronym: 'BR',
                }]
            }
            document.getElementById('name')?.classList?.remove('is-valid');
            document.getElementById('phone')?.classList?.remove('is-valid');
            document.getElementById('name')?.classList?.remove('is-invalid');
            document.getElementById('phone')?.classList?.remove('is-invalid');
            document.getElementById('taxpayer')?.classList?.remove('is-valid');
            document.getElementById('taxpayer')?.classList?.remove('is-invalid');
        },

        deleteClient(position) {
            this.clients.splice(position, 1);
            this.clientsIds.splice(position, 1);
        },

        reserveDurationValidate() {
            if (this.reserve.reserve_duration) {
                var timeReserve = this.reserve.reserve_duration.split(":");

                if (timeReserve[1] > 59) {
                    this.reserveInvalid(this.t('GENERAL.MSG.INCORRECT_MINUTES'));
                }
            } else if (this.hasDuration) {
                this.reserveInvalid(this.t('GENERAL.MSG.REQUIRED_FIELD'));
            }
        },

        reserveInvalid(msg) {
            this.msgReserve = msg;
            this.invalid.push(true);
            document.getElementById('invalidReserve').style.display = 'block';
            document.getElementById('reserveDuration').classList.add('is-invalid');
        },

        inputReserve() {
            if (this.hasDuration) {
                document.getElementById('invalidReserve').style.display = 'none';
                document.getElementById('reserveDuration').classList.remove('is-valid');
                document.getElementById('reserveDuration').classList.remove('is-invalid');
                this.reserveDurationValidate();
            }
        },

        searchClient(client) {
            this.invalid = [];
            this.validateTaxpayer(client.taxpayer);
            if (this.invalid.length == 0) {
                this.$store.commit('changeLoading', true);
                const tax = Buffer.from(client.taxpayer).toString('base64');
                Clients.showByTaxpayer(tax).then(resp => {
                    if (resp.data.id) {
                        if (!resp.data?.phones?.length) {
                            resp.data.phones = [{
                                type: 1,
                                number: '',
                                description: null,
                                code_country: this.client?.phones[0]?.code_country ? parseInt(this.client.phones[0].code_country) : 55,
                                country_acronym: this.client?.phones[0]?.country_acronym ? this.client.phones[0].country_acronym : 'BR',
                            }];
                        }
                        this.$refs.vueTelBase.choose(resp.data?.phones[0]?.country_acronym ? resp.data.phones[0].country_acronym : 'BR');
                        if (resp.data?.created_by && !this.reserve?.realtor_id) {
                            this.realtors.forEach(i => {
                                if (i.id === resp.data?.created_by) {
                                    this.reserve.realtor_id = i.id;
                                }
                            });
                        }
                        this.isEmailNull = !resp.data.email;
                        if (resp.data.company_id !== localStorage.getItem('companyId')) {
                            resp.data.id = null;
                            this.client = resp.data;
                            this.client.id = null;
                        } else {
                            this.client = resp.data;
                        }
                        this.inputName(this.client.name);
                    } else {
                        this.client = {
                            taxpayer: client.taxpayer,
                            name: null,
                            email: null,
                            allotment_id: this.reserve?.allotment_id,
                            phones: [{
                                type: 1,
                                number: '',
                                description: null,
                                code_country: this.client?.phones[0]?.code_country ? parseInt(this.client.phones[0].code_country) : 55,
                                country_acronym: this.client?.phones[0]?.country_acronym ? this.client.phones[0].country_acronym : 'BR',
                            }]
                        };
                    }
                    this.$store.commit('changeLoading', false);
                })
            }
        },

        checkSingularClient() {
            let hasClient = false;
            if (this.client.taxpayer) hasClient = true;
            if (this.client.name) hasClient = true;
            if (this.client?.phones[0] && this.client.phones[0]?.number) hasClient = true;

            if (hasClient) {
                document.getElementById('clients').style.backgroundColor = 'rgba(233,142,142,0.3)';
                this.toast.error(this.t('RESERVE.ADD_CLIENT_OR_CLEAR'));
            } else {
                document.getElementById('clients').style.backgroundColor = '';
            }
            return hasClient;
        },

        create() {
            if (this.isRequiredDataClient && !this.isAdmin) {
                if (this.clientsIds.length < 1) {
                    this.toast.error(this.t('GENERAL.MSG.PLEASE_ADD_A_CLIENT_TO_GO_AFTER'), {timeout: false});
                    return;
                }
            }
            if (this.checkForm()) {
                if (this.checkSingularClient()) return;
                this.$store.commit('changeLoading', true);
                this.updateForm();

                this.form.clients_reserve = this.clients
                Reserve.create(this.form, this.reserve.allotment_id).then(() => {
                    document.getElementById('closeX').click();
                    this.toast.success(this.t('GENERAL.MSG.REGISTER_SUCCESS'));
                    this.$store.commit('changeLoading', false);

                    if (this.reserve.isLotOrigin) {
                        let resp = {
                            allotment_id: this.reserve.allotment_id,
                            block_id: this.reserve.blocks
                        }
                        this.$emit('created', resp);
                    } else {
                        this.$emit('created');
                    }

                }).catch(error => {
                    this.errorMsg(error)
                    this.$store.commit('changeLoading', false);
                });
            }
        },


        updateForm() {
            this.reserve.clients = this.clientsIds;
            this.reserve.realtor = this.reserve.realtor == 0 ? null : this.reserve.realtor;
            this.reserve.reserve_type_id = this.reserve.reserve_type_id == 0 ? null : this.reserve.reserve_type_id;

            this.form = {
                observation: this.reserve.observation,
                property_id: this.reserve.property_id,
                reserve_type_id: this.reserve.reserve_type_id,
                realtor_id: this.reserve.realtor_id,
                reserve_duration: this.reserve.reserve_duration,
                clients: this.reserve.clients,
            }
        },

        async allotmentSelected(allotment_id, isMounted = false) {
            this.$store.commit('changeLoading', true);
            this.indexRealtor(allotment_id);
            this.indexBlocks(allotment_id);

            if (!isMounted) {
                this.selectGeneric(allotment_id, 'Allotment');
            }

            await Allotments.show(allotment_id).then(resp => {
                if (resp.data.reserve_duration_max) {
                    this.reserveDurationMax = resp.data.reserve_duration_max;

                    this.inputReserve();
                    this.indexReserveTypes(allotment_id);
                }
                this.isLoadingBlocks = false;
                this.$store.commit('changeLoading', false);
            }).catch(error => {
                this.errorMsg(error)
                this.$store.commit('changeLoading', false);
            });
        },

        blockSelected(block, allotment_id) {
            this.indexLots(allotment_id, block.text);
            this.selectGeneric(allotment_id, 'Block');
        },

        validateReserveDuration(typeReserveId, typeReserves) {
            this.hasDuration = typeReserves.find(t => t.id == typeReserveId).has_limit_time;

            if (!this.hasDuration) {
                this.reserve.reserve_duration = null;
            } else {
                this.reserve.reserve_duration = this.reserveDurationMax;
            }
        },

        observationChange(observation) {
            this.reserve.observation = observation;
        },
    }
}
</script>
<style scoped>
.right-content {
    justify-content: flex-end;
}

.padding {
    padding: 0.4rem;
}

.background-header {
    background-color: #eeeeee;
}

.background-table {
    background-color: #fff;
}

.card-custom {
    border-radius: 3px;
    margin-bottom: 1rem;
    border: 1px solid #d7dbe2;
    border-bottom: 1px solid #d7dbe2;
}

.border-top {
    border-top: 1px solid #dee2e6;
}

.padding-null {
    padding: 0.75rem;
}

.alin-text {
    align-items: center;
}

.btn-custom {
    cursor: pointer;
    text-decoration: none;
    display: inline-block;
    transition-duration: 0.4s;
}

.bg-btn {
    background-color: white !important;
    color: black !important;
}

.bg-btn:hover {
    background-color: #0e5e4e !important;
    color: white !important;
}

.reserve-info-card {
    margin-bottom: 1rem;
}

.reserve-allotment-display {
    align-items: center;
    background: #eef7f4;
    border: 1px solid #d7e9e3;
    border-radius: 14px;
    display: inline-flex;
    gap: 9px;
    min-width: 180px;
    padding: 8px 12px;
}

.reserve-allotment-display__icon {
    align-items: center;
    background: #0e5e4e;
    border-radius: 10px;
    color: #ffffff;
    display: inline-flex;
    flex: 0 0 30px;
    height: 30px;
    justify-content: center;
    width: 30px;
}

.reserve-allotment-display__content {
    min-width: 0;
}

.reserve-allotment-display__label {
    color: #7b8794;
    display: block;
    font-size: 0.62rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    margin-bottom: 4px;
    text-transform: uppercase;
}

.reserve-allotment-display strong {
    color: #26323f;
    display: block;
    font-size: 0.82rem;
    font-weight: 700;
    line-height: 1.35;
}

.reserve-observation-field {
    margin-top: 0.5rem;
}

.reserve-observation-field__label {
    align-items: center;
    color: #0e5e4e;
    display: inline-flex;
    font-size: 0.82rem;
    font-weight: 700;
    gap: 7px;
    letter-spacing: 0.02em;
    margin-bottom: 7px;
}

.reserve-observation-field__label i {
    font-size: 0.95rem;
}

.reserve-observation-field__textarea {
    min-height: 84px;
}

:global(html.dark-theme .reserve-allotment-display ){
    background: rgba(20, 184, 166, 0.12) !important;
    border-color: rgba(94, 234, 212, 0.18) !important;
}

:global(html.dark-theme .reserve-allotment-display__icon ){
    background: rgba(20, 184, 166, 0.22) !important;
    color: #5eead4 !important;
}

:global(html.dark-theme .reserve-allotment-display__label ){
    color: var(--dark-text-muted) !important;
}

:global(html.dark-theme .reserve-allotment-display strong ){
    color: var(--dark-text) !important;
}

:global(html.dark-theme .reserve-observation-field__label ){
    color: var(--dark-primary) !important;
}

.reserve-clients-section {
    margin-bottom: 1.25rem;
}

.reserve-clients-add {
    align-items: center;
    border-radius: 10px;
    display: inline-flex;
    gap: 8px;
    height: 36px;
    justify-content: center;
    padding-left: 14px;
    padding-right: 14px;
    white-space: nowrap;
}

.reserve-clients-panel {
    background: #f7f9fc;
    border: 1px solid #dde4ee;
    border-radius: 14px;
    box-shadow: 0 10px 28px rgba(31, 45, 61, 0.07);
    overflow: hidden;
    padding: 10px;
}

.reserve-clients-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.reserve-client-card {
    align-items: center;
    background:
        linear-gradient(135deg, #ffffff 0%, #fbfcfd 100%);
    border: 1px solid #dfe7ef;
    border-radius: 12px;
    display: flex;
    gap: 12px;
    justify-content: space-between;
    padding: 12px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.reserve-client-card:hover {
    border-color: rgba(14, 94, 78, 0.28);
    box-shadow: 0 12px 26px rgba(31, 45, 61, 0.08);
    transform: translateY(-1px);
}

.reserve-client-card__avatar {
    align-items: center;
    background: linear-gradient(135deg, #0e5e4e 0%, #15936f 100%);
    border-radius: 14px;
    box-shadow: 0 10px 22px rgba(14, 94, 78, 0.18);
    color: #ffffff;
    display: flex;
    flex: 0 0 44px;
    font-size: 1rem;
    font-weight: 800;
    height: 44px;
    justify-content: center;
    text-transform: uppercase;
}

.reserve-client-card__main {
    align-items: center;
    display: grid;
    flex: 1;
    gap: 16px;
    grid-template-columns: minmax(180px, 1fr) minmax(320px, 2fr);
    min-width: 0;
}

.reserve-client-card__identity,
.reserve-client-card__field {
    min-width: 0;
}

.reserve-client-card__identity strong,
.reserve-client-card__email,
.reserve-client-card__taxpayer {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.reserve-client-card__identity strong {
    color: #26323f;
    font-size: 0.9rem;
    font-weight: 600;
    line-height: 1.35;
}

.reserve-client-card__taxpayer {
    align-items: center;
    background: #f2f7f5;
    border: 1px solid #e0ebe7;
    border-radius: 999px;
    color: #6f7d8c;
    display: inline-flex;
    font-size: 0.82rem;
    gap: 6px;
    margin-top: 4px;
    max-width: 100%;
    padding: 4px 9px;
    width: fit-content;
}

.reserve-client-card__details {
    align-items: end;
    display: grid;
    gap: 14px;
    grid-template-columns: minmax(170px, 220px) minmax(180px, 1fr);
    min-width: 0;
}

.reserve-client-card__label {
    color: #7b8794;
    display: block;
    font-size: 0.68rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    margin-bottom: 5px;
    text-transform: uppercase;
}

.reserve-client-card__email {
    align-items: center;
    background: #f7f9fc;
    border: 1px solid #e5ebf2;
    border-radius: 10px;
    color: #384555;
    display: inline-flex;
    font-size: 0.88rem;
    gap: 7px;
    line-height: 38px;
    max-width: 100%;
    min-height: 38px;
    padding: 0 11px;
    width: 100%;
}

.reserve-client-card__email--empty {
    color: #8a96a3;
    font-style: italic;
}

.reserve-client-card__field--phone ::v-deep .vue-tel-input {
    background: #f9fbfd;
    border-color: #dce4ed;
    border-radius: 10px;
    min-height: 38px;
}

.reserve-client-card__actions {
    align-items: center;
    display: flex;
    flex-shrink: 0;
}

.reserve-client-card__delete {
    align-items: center;
    border: 1px solid #e3e8ef;
    border-radius: 10px;
    display: inline-flex;
    gap: 6px;
    height: 36px;
    justify-content: center;
    min-width: 94px;
    padding: 0 11px;
}

.reserve-clients-empty {
    align-items: center;
    background: #ffffff;
    border: 1px dashed #cfd8e3;
    border-radius: 12px;
    color: #7b8794;
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: center;
    min-height: 118px;
    padding: 18px;
}

.reserve-clients-empty strong {
    color: #384555;
    font-size: 0.92rem;
}

.reserve-clients-empty p,
.reserve-clients-empty small {
    margin: 0;
}

.reserve-clients-empty small {
    color: #dc3545;
    font-size: 0.76rem;
    font-weight: 600;
}

.reserve-clients-empty__icon {
    align-items: center;
    background: #edf5f2;
    border-radius: 50%;
    color: #0e5e4e;
    display: inline-flex;
    height: 38px;
    justify-content: center;
    width: 38px;
}

:global(html.dark-theme .reserve-client-card__label),
:global(html.dark-theme .reserve-client-card__taxpayer),
:global(html.dark-theme .reserve-clients-empty ){
    color: #a9b4c2;
}

:global(html.dark-theme .reserve-clients-panel ){
    background: #151b24;
    border-color: #2a3340;
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.28);
}

:global(html.dark-theme .reserve-client-card),
:global(html.dark-theme .reserve-clients-empty ){
    background: linear-gradient(135deg, #1c2430 0%, #172033 100%);
    border-color: #303b49;
}

:global(html.dark-theme .reserve-client-card:hover ){
    border-color: rgba(64, 191, 158, 0.34);
    box-shadow: 0 12px 26px rgba(0, 0, 0, 0.26);
}

:global(html.dark-theme .reserve-client-card__identity strong),
:global(html.dark-theme .reserve-client-card__email),
:global(html.dark-theme .reserve-clients-empty strong ){
    color: #edf2f7;
}

:global(html.dark-theme .reserve-client-card__avatar ){
    background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
    box-shadow: 0 10px 24px rgba(20, 184, 166, 0.18);
    color: #ffffff;
}

:global(html.dark-theme .reserve-client-card__taxpayer),
:global(html.dark-theme .reserve-client-card__email ){
    background: rgba(15, 23, 42, 0.54) !important;
    border-color: rgba(148, 163, 184, 0.18) !important;
    color: #edf2f7 !important;
}

:global(html.dark-theme .reserve-client-card__email--empty ){
    color: #94a3b8;
}

:global(html.dark-theme .reserve-client-card__field--phone .vue-tel-input ){
    background: #111823;
    border-color: #384456;
}

:global(html.dark-theme .reserve-client-card__delete ){
    background: #243040 !important;
    border-color: #384456;
    color: #edf2f7 !important;
}

:global(html.dark-theme .reserve-clients-empty__icon ){
    background: rgba(64, 191, 158, 0.14);
    color: #40bf9e;
}

.modal {
    position: absolute;
}
@media (max-width: 810px) {
    ::v-deep .vti__dropdown-list{
        width: 47vw;
        max-width: 350px;
    }

    .reserve-clients-add {
        width: 100%;
    }

    .reserve-client-card {
        align-items: stretch;
        flex-direction: column;
    }

    .reserve-client-card__avatar {
        display: none;
    }

    .reserve-client-card__main,
    .reserve-client-card__details {
        grid-template-columns: 1fr;
    }

    .reserve-client-card__email {
        line-height: 1.35;
        white-space: normal;
    }

    .reserve-client-card__actions {
        justify-content: flex-end;
    }

    .reserve-client-card__delete {
        width: 100%;
    }
}
</style>
